import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  variant?:
    | 'primary'
    | 'secondary'
    | 'secondary-mono'
    | 'link'
    | 'link-mono'
    | 'outline'
    | 'outline-white'
    | 'mono-white';
  noText?: boolean;
  link?: boolean;
  to?: string;
}

interface Emits {
  (event: 'click', payload: Event): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiButton.ts',
  props: {
    disabled: { type: Boolean, default: false },
    size: { default: 'md' },
    variant: { default: 'secondary-mono' },
    noText: { type: Boolean, default: false },
    link: { type: Boolean, default: false },
    to: { default: '' }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'click', payload: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled: boolean, size: 'sm' | 'md' | 'lg', variant:
    | 'primary'
    | 'secondary'
    | 'secondary-mono'
    | 'link'
    | 'link-mono'
    | 'outline'
    | 'outline-white'
    | 'mono-white', noText: boolean, link: boolean, to: string };



const componentTag = computed<string>(() => (props.link && props.to ? 'router-link' : 'button'));

return { __sfc: true,props, emit, componentTag }
}

})